import { format } from 'date-fns'

export const formatDate = (date: Date) => format(date, 'do MMM y')
export const formatDateTime = (date: Date) => format(date, 'do MMM y, H:mm')
